// ESM-Huelle fuer lib/scripts/components/CMP_CNumPad.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CNumPad(id) {
    this.construct(id);

    this.name = "CNumPad";
    this.htmlType = "span";

    this.Pp = null;
    this.controlFields = new Array();
    this.properties = {
        ok: false,
        cancel: false,
        next: false,
        callback: {
            cls: null,
            fnc: null
        }
    }

    this.setStyleFromXML();
}

CNumPad.prototype = new CComponent;

CNumPad.prototype.prepare = function() {
    this.Pp = this.addChild(CPushPanel);

    this.Pp.clickWork = this.clickWork;

    this.Pp.properties = combine(this.Pp.properties, this.properties);

    var keys, keyValues;

    switch (this.Pp.properties.type) {
        case "phoneAmount":
            keys = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, ",", 0, "00");
            keyValues = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, ".", 0, ".00");
            break;
        case "keyboardAmount":
            keys = new Array(7, 8, 9, 4, 5, 6, 1, 2, 3, 0, "00", ",");
            keyValues = new Array(7, 8, 9, 4, 5, 6, 1, 2, 3, 0, ".00", ".");
            break;
        case "phone":
            keys = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, null);
            if (this.properties.ok)
                keys[11] = "OK";
            if (this.properties.next)
                keys[11] = "NX";
            if (this.properties.cancel)
                keys[9] = "XX";
            keyValues = keys;
            break;
        case "keyboard":
            keys = new Array(7, 8, 9, 4, 5, 6, 1, 2, 3, 0, null, null);
            if (this.properties.ok)
                keys[10] = "OK";
            if (this.properties.next)
                keys[10] = "NX";
            if (this.properties.cancel)
                keys[11] = "XX";
            keyValues = keys;
            break;
        case "message":
            keys = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, "BS", 0, "RET");
            keyValues = keys;
            break;
    }

    for (var i in keys) {
        this.Pp.buttons[i] = new CPushButton;
        this.Pp.buttons[i].properties = combine(this.Pp.buttons[i].properties,
            this.Pp.properties.buttons);
        if (keys[i] == null)
            this.Pp.buttons[i].properties.styles.visibility = "hidden";
        else {
            this.Pp.buttons[i].properties.caption.value = keys[i].toString();
            this.Pp.buttons[i].properties.keyValue = keys[i].toString();
            this.Pp.buttons[i].properties.events.onMousedown = this.Pp.clickWork;

            if (keys[i] == "OK") {
		
                this.Pp.buttons[i].properties.class="OK";
                this.Pp.buttons[i].properties.caption.value = "";
               this.Pp.buttons[i].properties.events.onMousedown = this.gotOK;
               this.Pp.buttons[i].properties.attributes.onMousedown_parameter_0 = this.id;
            }
            if (keys[i] == "XX") {
		 this.Pp.buttons[i].properties.class="X";
                this.Pp.buttons[i].properties.caption.value = "X";
                this.Pp.buttons[i].properties.events.onMousedown = this.gotCancel;
               this.Pp.buttons[i].properties.attributes.onMousedown_parameter_0 = this.id;
            }
            if (keys[i] == "NX") {
                this.Pp.buttons[i].properties.caption.value = "";
                this.Pp.buttons[i].properties.styles.backgroundImage = "url(lib/img/bonedit/07scrolldown.png)";
                this.Pp.buttons[i].properties.styles.backgroundRepeat = "no-repeat";
                this.Pp.buttons[i].properties.styles.backgroundPosition = "center";
                this.Pp.buttons[i].properties.events.onMousedown = this.gotOK;
                this.Pp.buttons[i].properties.attributes.onMousedown_parameter_0 = this.id;
            }
            if (keys[i] == "BS") {
                this.Pp.buttons[i].properties.keyValue = keyValues[i];
                this.Pp.buttons[i].properties.caption.value = "&#8592;";
                // ESM-Welle 5b: wirkungslos seit jeher. Pp.buttons[i] ist ein CPushButton
                // (numpad.js:74), und dessen properties.caption.styles ist ein STRING -
                // etc/defaults/LYT_CPushButton.xml hat dort ein Whitespace-<styles>, das
                // CXmlHandler.getObject zu textContent macht. Sloppy-Mode verwarf die
                // Zuweisung still, im Modul (strict) wirft sie. Stilllegen ist wertgleich;
                // wirksam gemacht wuerde sie die Glyphengroesse aendern (Regel 1).
                // this.Pp.buttons[i].properties.caption.styles.fontSize = "10vh";
            }
            if (keys[i] == "RET") {
                this.Pp.buttons[i].properties.keyValue = keyValues[i];
                this.Pp.buttons[i].properties.caption.value = "&#x2193;";
                // ESM-Welle 5b: wirkungslos seit jeher. Pp.buttons[i] ist ein CPushButton
                // (numpad.js:74), und dessen properties.caption.styles ist ein STRING -
                // etc/defaults/LYT_CPushButton.xml hat dort ein Whitespace-<styles>, das
                // CXmlHandler.getObject zu textContent macht. Sloppy-Mode verwarf die
                // Zuweisung still, im Modul (strict) wirft sie. Stilllegen ist wertgleich;
                // wirksam gemacht wuerde sie die Glyphengroesse aendern (Regel 1).
                // this.Pp.buttons[i].properties.caption.styles.fontSize = "5.5vh";
            }

        }
    }

    this.prepared = true;
}




/*
CNumPad.prototype.addEvents = function(e,me) {

   var id = me.id;
   //var me = this;

   var el =  e.getElementsByClassName('CCaption');
   var parameters=[id];
   this.addOnclickEvent(el,parameters, me, me.doclick);


}*/

CNumPad.prototype.doclick = function(component, parameters) {
	var comp = POS.getComponentById(parameters[0]);
	
	switch (component.textContent){
		case "0":
 		case "1":
 		case "2":
 		case "3":
 		case "4":
 		case "5":
 		case "6":
 		case "7":
 		case "8":
 		case "9":
			comp.clickWork(component, parameters, component.textContent);
		break;
   		case "X":
			comp.gotCancel(component, parameters);	
		break;
		default:
       			comp.gotOK(component, parameters);
	}

}



CNumPad.prototype.clickWork = function(component, parameters) {
    if (POS.focusedComponent != null &&
        typeof POS.focusedComponent.gotKey == "function") {
        POS.focusedComponent.gotKey(component.properties.keyValue);
    }
}

CNumPad.prototype.gotOK = function(component, parameters) {
    var comp = POS.getComponentById(parameters[0]);

    if (POS.focusedComponent == comp.controlFields[comp.controlFields.length - 1])
        comp.controlFields[comp.controlFields.length - 1].gotOK();
    else
        for (var i = 0; i < comp.controlFields.length - 1; i++)
            comp.controlFields[i].gotOK();
}

CNumPad.prototype.gotCancel = function(component, parameters) {
    var comp = POS.getComponentById(parameters[0]);

    for (var i = comp.controlFields.length - 1; i >= 0; i--)
        comp.controlFields[i].gotClear();
}


export { CNumPad };
